import * as React from "react";
import {cx} from "emotion";

import "./normal-mode.scss";

import {bindInput}           from "@Common/react/bind-input";
import {cs}                  from "@Common/react/chain-services";
import {consumeContext}      from "@Common/react/context";
import {scopedState}         from "@Common/react/scoped-state";
import {scn}                 from "@Common/react/state-change-nested-value";
import {UseState}            from "@Common/react/use-state";
import {downloadArrayBuffer} from "@Common/utils/browser/download-array-buffer";

import {formatImageSize} from "../../format-image-size";
import {ClearableSelect} from "../clearable-select/clearable-select";

export const NormalMode = (
    {
        modal,
        typeLabel,
        onEdit,
        onDelete,
        onImageEffects,
        onRemoveBackground,
        allowDefaultOption,
        next
    }
) => cs(
    consumeContext("company"),
    ["updating", (_, next) => UseState({next, initValue: false})],
    ["state", (_, next) => UseState({next, initValue: {name: modal.data.name, defaultSlot: modal?.data?.defaultSlot}})],
    ({company, updating, state}) => next({
        onSave: async () => {
            updating.onChange(true);
            onEdit({id: modal.data.id, data: state.value});
            updating.onChange(false);
            modal.close();
        },
        isDisabled: !state.value.name || updating.value,
        render: () => (
            <div className="normal-mode-9b8">
                <div className="top">
                    <div className="card">
                        <div className="img-container">
                            <img
                                className="uploaded"
                                src={modal.data.thumbnailUrl}
                                alt={modal.data.name}
                                xd-qa-type="image"
                                xd-qa-name="headshot"
                            />
                        </div>
                        <div className="right">
                            <div className="info">
                                <div className="name-and-quality">
                                    <div
                                        title={modal.data.name + "." + modal.data.fileType}
                                        className="file-name"
                                        xd-qa-name="File Name"
                                        xd-qa-type="label"
                                    >
                                        {modal.data.name + "." + modal.data.fileType}
                                    </div>
                                    <div
                                        className={cx("quality", {
                                            high: modal.data.quality === "High",
                                            medium: modal.data.quality === "Medium",
                                            low: modal.data.quality === "Low",
                                        })}
                                        xd-qa-name="Quality"
                                        xd-qa-type="label"
                                    >
                                        {modal.data.quality}
                                    </div>
                                </div>
                                <div
                                    className="file-size"
                                    xd-qa-name="File Size"
                                    xd-qa-type="label"
                                >
                                    {formatImageSize(modal.data.fileSize)}
                                </div>
                            </div>
                            <div className="actions">
                                <button
                                    className={cx("image-effects")}
                                    xd-qa-type="link"
                                    xd-qa-name="Image Effects"
                                    onClick={() => onImageEffects()}
                                >
                                    Image Effects
                                </button>
                                <div className="line"/>
                                {modal.data.defaultSlot !== undefined && company?.prefs?.enableCutoutPro && onRemoveBackground && (<>
                                    <button
                                        className={cx("image-effects")}
                                        xd-qa-type="link"
                                        xd-qa-name="Remove Background"
                                        onClick={() => onRemoveBackground()}
                                    >
                                        Remove Background
                                    </button>
                                    <div className="line"/>
                                </>)}
                                <button
                                    className="download"
                                    onClick={() =>
                                        fetch(modal.data.printUrl || modal.data.imageUrl, {
                                            method: "GET",
                                        }).then(response => {
                                            response.arrayBuffer().then(function(buffer) {
                                                downloadArrayBuffer(buffer, {fileName: modal.data.name + "." + modal.data.fileType});
                                            });
                                        }).catch(() => {
                                            alert("Error: Could not create image download.");
                                        })
                                    }
                                    xd-qa-type="link"
                                    xd-qa-name="Download"
                                >
                                    Download
                                </button>
                                <div className="line"/>
                                <button
                                    className="delete"
                                    xd-qa-type="link"
                                    xd-qa-name="Delete"
                                    onClick={() => onDelete(modal)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="text">
                        <div {...{
                            className: "name-your-photo",
                            "xd-qa-type": "label",
                            "xd-qa-name": "Name your Photo",
                        }}>
                            Name your Photo
                        </div>
                        <div className="asterisk">
                            *
                        </div>
                    </div>
                    <input
                        className="name"
                        {...bindInput(scopedState(state, ["name"]))}
                        xd-qa-type="text_field"
                        xd-qa-name="Name your Photo"
                    />
                    {modal.data.defaultSlot !== undefined && !!allowDefaultOption && (
                        <div className="default-dropdown">
                            {ClearableSelect<number>({
                                list: allowDefaultOption === 1 ? [1] : [1, 2],
                                placeholder: "Make Default",
                                xdQaName: "Make Default",
                                isSelected: v => v === state.value.defaultSlot,
                                onSelect: index => scn(state, ["defaultSlot"], () => index),
                                onClear: () => scn(state, ["defaultSlot"], () => 0),
                                getToggleLabel: i => "Default " + typeLabel.replace("Default ", "") + " #" + i,
                                getExpandLabel: i => typeLabel + " #" + i,
                            })}
                        </div>
                    )}
                </div>
            </div>
        )
    })
);
